import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { InfoBlock } from '../../components';
import './InfoGroup.css';

export default class InfoGroup extends Component {
  static propTypes = {
    data: PropTypes.array,
    className: PropTypes.string
  }

  render() {

      if(this.props.className && this.props.className === 'WidgetPieNumeric') {
        return (
          <div className={`InfoGroup ${this.props.className ? this.props.className : ''}`}>
            {this.props.data.map((item, idx) => {
              let borders = [];
              if (idx === 0) borders = [0, 1, 0, 0];
              else if (idx === 1) borders = [0, 0, 0, 0];
              else if (idx === 2) borders = [0, 1, 1, 0];
              else if (idx === 3) borders = [0, 0, 1, 0];
              else if (idx === 4) borders = [0, 1, 1, 0];
              else if (idx === 5) borders = [0, 0, 1, 0];
              return (
                <div>
                  {/* <InfoBlock className={`InfoBlock${idx}`} borders={borders} color={this.props.colorScheme[idx]} {...item} /> */}
                  <InfoBlock className={`InfoBlock${idx}`} color={this.props.colorScheme[idx]} {...item} />
                </div>
              )
            })}
          </div>
        )
      } else {
        return (
          <div className={`InfoGroup ${this.props.className ? this.props.className : ''}`}>
            {this.props.data.map((item, idx) => {
              let borders = [];
              if (idx === 0) borders = [0, 1, 0, 0];
              else if (idx === 1) borders = [0, 0, 0, 0];
              else if (idx === 2) borders = [0, 1, 1, 0];
              else if (idx === 3) borders = [0, 0, 1, 0];
              return (
                <div>
                  <InfoBlock className={`InfoBlock${idx}`} borders={borders} {...item} />
                </div>
              )
            })}
          </div>
        )
      }
  }
}



// WEBPACK FOOTER //
// ./src/components/InfoGroupComponent/InfoGroup.js